import { promiseWrapper } from 'utils/promise'

declare let USER_BASE_URL_IK: string

export type NewsletterResponse =
  | { status: 202; response: 'EMAIL_ADDED' }
  | { status: 400; response: '3RD_PARTY_API_ERROR' }
  | { status: 401; response: '3RD_PARTY_API_AUTH_ERROR' }
  | { status: 409; response: 'ALREADY_SUBSCRIBED' }
  | { status: 422; response: 'INVALID_EMAIL' }
  | { status: 422; response: 'INVALID_LIST' }
  | { status: 429; response: '3RD_PARTY_API_ERROR' }
  | { status: 500; response: '3RD_PARTY_API_ERROR' }

interface FormPayload {
  email: string
  list?: 'c' | '4' // 'c' newsletter token, '4' token for tests
}

export function signUpForNewsletter(payload: FormPayload): Promise<NewsletterResponse> {
  const { email, list = 'c' } = payload
  return promiseWrapper<NewsletterResponse, FormPayload>(
    `${USER_BASE_URL_IK}/api/public/subscribe-to-newsletter`,
    'POST',
    { email, list },
  )
}
